module.exports = __webpack_public_path__ + "img/scheduleInfo.a4a72363.svg";